let ol = require('openlayers');
let jsts = require('jsts/dist/jsts');
let parser = new jsts.io.OL3Parser(undefined, ol);

let AbstractOperation = require('../operations/abstract');
let IsTouchedResult = require('../operations/types/isTouchedResult');


/**
 * Класс IsTouched
 * @extends AbstractOperation
 */
class IsTouched extends AbstractOperation {

    /**
     * Создает экземпляр класса IsTouched
     */
  constructor() {
    super()
  }


    /**
     *
     * @param featureA
     * @param featureB
     * @return {boolean}
     */
    execute(featureA, featureB) {
        let isTouched = operation(featureA, featureB);

        return new IsTouchedResult({
            result: isTouched
        })
    }
    }

function operation(featureA, featureB) {
    let geomA = parser.read(featureA.getGeometry());
    let geomB = parser.read(featureB.getGeometry());
    let result = geomA.touches(geomB);
    return result
}



module.exports = IsTouched;